module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-29.1-553c324e11577e6370720a2ec6f7016b.svg";